import { addDays, startOfDay } from 'date-fns';
import * as Yup from 'yup';

// validation for start date of mc product submissions
export const mcStartDateValidation = (dateKey: string) =>
  Yup.date()
    // cannot select past dates, except for prefilled dates
    .test(
      'is-valid-date',
      'Start date cannot be in the past',
      (value, context) => {
        if (!(value instanceof Date) || isNaN(value.getTime())) {
          return false;
        }

        const today = startOfDay(new Date());
        // Check if value is prefilled
        const isPrefilled = !!context.parent[dateKey];

        // Allow the prefilled date even if it's in the past
        if (isPrefilled) return true;

        return value >= today;
      },
    )
    .typeError('Please select a start date')
    .required('Required');

export const mcEndDateValidation = (dateKey: string) =>
  Yup.date()
    .typeError('Please select an end date')
    .required('Required')
    .when(dateKey, (startDate: Date, schema: Yup.DateSchema) => {
      if (startDate) {
        return schema.min(
          addDays(startOfDay(startDate), 1),
          'End date must be strictly after the start date',
        );
      }
      return schema;
    });
